import { Editor } from "grapesjs";

export default (editor: Editor) => {
  const blockManager = editor.BlockManager;
  const domComponents = editor.DomComponents;

  domComponents.addType("link-block", {
    extend: "default",
    model: {
      defaults: {
        tagName: "a",
        droppable: true,
        style: {
          padding: "10px",
          display: "inline-block",
          "min-width": "100px",
          "min-height": "50px"
        },
        attributes: {
          href: "#", // Default href
        },
        traits: [
          {
            type: "text",
            label: "URL",
            name: "href",
            changeProp: true, // Triggers change in properties
          },
          {
            type: 'checkbox',
            label: 'Open in new tab',
            name: 'target',
            valueTrue: '_blank',
            valueFalse: '_self',
            changeProp: true, // Triggers change in properties
          }
        ],
      },
      init() {
        this.listenTo(this, "change:href", this.updateHref);
        this.listenTo(this, "change:target", this.updateTarget);
      },
      updateHref() {
        const href = this.get("href");
        this.set("attributes", { ...this.get("attributes"), href });
      },
      updateTarget() {
        const target = this.get("target");
        this.set("attributes", { ...this.get("attributes"), target });
      }
    },
    view: {
      onRender() {
        const href = this.model.get("attributes")?.href || "#";
        this.el.setAttribute("href", href);
      },
    },
  });

  // Add the block to the block manager
  blockManager.add("link-block", {
    label: "Link Block",
    category: "Basic",
    media: `<i class="fa-kit fa-cs-link-block fs-2"></i>`,
    content: {
      type: "link-block",
    },
  });
};
